import { OpenAPI as VaultAPI } from '../services/vault';
import { OpenAPI as AgentsAPI } from '../services/general';
import { OpenAPI as ConversationsAPI } from '../services/conversations';

export { getOrgId } from '../utilities';

export * from './agents';
export * from './context';
export * from './conversations';
export * from './callmanagement';

if (process.env.NODE_ENV === 'development') {
  AgentsAPI.BASE = '/api';
  VaultAPI.BASE = '/vault';
  ConversationsAPI.BASE = '/app';
} else {
  VaultAPI.BASE = process.env.REACT_APP_API_URL.replace('/api', '');
  ConversationsAPI.BASE = process.env.REACT_APP_API_URL.replace('/api', '/app');
  AgentsAPI.BASE = process.env.REACT_APP_API_URL.replace(
    '/api',
    '/app/management'
  );
}

export { AgentsAPI, VaultAPI, ConversationsAPI };
